const mutationTypes = {
  SET_SELECTED_TEMPLATE: 'setSelectedTemplate',
  SET_SELECTED_CASE: 'setSelectedCase'
};

const state = {
  selectedTemplate: null,
  selectedCase: null
};

const mutations = {
  [mutationTypes.SET_SELECTED_TEMPLATE]: (state, data) => {
    state.selectedTemplate = data;
  },
  [mutationTypes.SET_SELECTED_CASE]: (state, data) => {
    state.selectedCase = data;
  }
};

const actions = {
  setSelectedTemplate: ({commit}, data) => {
    commit(mutationTypes.SET_SELECTED_TEMPLATE, data);
  },
  setSelectedCase: ({commit}, data) => {
    commit(mutationTypes.SET_SELECTED_CASE, data);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
